import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EntityTypes } from '../../entity/entity-types';
import { CarbonForm } from './models/form';
import { CarbonFormListParams } from './models/form-list-params';
import { CarbonFormPayload } from './models/form-payload';
import { AppFile } from '../../../shared/models/file';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class CarbonFormService
  extends StoreBaseService<CarbonForm, CarbonFormPayload, CarbonFormListParams> {

  get entityType(): string {
    return EntityTypes.carbonForm;
  }

  get resourceName(): string {
    return 'carbon/form';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }

  pdf(locale: string): Observable<AppFile> {
    const url = `${this.apiUrl}/${locale}/api/carbon/form-id/generate-pdf`;
    return this.http.post<Blob>(url, {
      numberOfIds: 120
    }, {
      responseType: 'blob' as 'json',
      observe: 'response'
    }).pipe(
      map((res: HttpResponse<Blob>) => ({ file: res.body }))
    );
  }
}
